const API_URL = process.env.REACT_APP_API_URL;
const baseApiUrl = `${API_URL}/api/instant-win`;

export const instantWinEndpoints = {
    register: `${baseApiUrl}/register-venue`,
    registerCheck: `${baseApiUrl}/register-check/`,
    unique: `${baseApiUrl}/unique-code/`,
    delay: `${baseApiUrl}/check-delay/`,
    distance: `${baseApiUrl}/distance/`,
    swipe: `${baseApiUrl}/swipe/`,
    redeem: `${baseApiUrl}/redeem/`,
    venueSelect: `${baseApiUrl}/venue-select/`,
    selectedVenue: `${baseApiUrl}/selected-venue/`,
    instant: `${baseApiUrl}`,
    locations: `${baseApiUrl}/locations`,
};
